var React = require('react');

function SliderArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33 2L3 32L33 62","stroke":"black","strokeWidth":"4"}));
}

SliderArrowLeft.defaultProps = {"width":"35","height":"64","viewBox":"0 0 35 64","fill":"none"};

module.exports = SliderArrowLeft;

SliderArrowLeft.default = SliderArrowLeft;
